/* React */
import React from "react";

/* Ionic */
import { document, trash } from "ionicons/icons";

/* React Redux */
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";

/* Thunks */
import { deleteTestData } from "src/redux/thunks/test-data/testDataThunk";

/* Components */
import ToolbarContainer from "src/components/admin-dashboard/data-handler/toolbar-container/ToolbarContainer";
import ItemSlidingOptions from "src/components/admin-dashboard/data-handler/item-sliding-options/ItemSlidingOptions";
import ItemOption from "src/components/admin-dashboard/data-handler/item-option/ItemOption";

/* Stylesheet */
import styles from "./CurrentDataHandler.module.scss";

/* Interfaces */
import { TestDataProps } from "src/shared/interfaces/common/TestData";

interface CurrentDataHandlerProps {
  importedData: TestDataProps[];
}

const CurrentDataHandler: React.FC<
  CurrentDataHandlerProps
> = ({ importedData }) => {
  const dispatch = useDispatch<AppDispatch>();
  const disabled = importedData.length === 0;

  return (
    <div className={styles.current_data_handler}>
      <ToolbarContainer
        label={"Current data"}
        icon={document}
      />
      {!disabled ? (
        importedData.map((item, index) => {
          return (
            <ItemSlidingOptions
              key={index}
              item={item}
              disabled={false}
              option={
                <ItemOption
                  label={"Delete"}
                  icon={trash}
                  onClick={() => {
                    dispatch(deleteTestData(item));
                  }}
                  scssProps={{
                    backgroundColor:
                      "var(--ion-color-error)",
                  }}
                />
              }
            />
          );
        })
      ) : (
        <div className={styles.no_data_container}>
          <div className={styles.label}>No data</div>
        </div>
      )}
    </div>
  );
};

export default CurrentDataHandler;
